<template>
  <h1 class="text-center">Headers</h1>
</template>

<script>
export default {
  name: "Headers"
}
</script>

<style scoped>

</style>